module.exports = __webpack_public_path__ + "img/photo-51.23c9d0de.png";